import { fromFetch } from 'rxjs/fetch';
import { environment } from 'src/environments/environment';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { authwsEnvironment } from './authws-environment';
import { authUserSchema } from './schemas/auth-user.schema';

export function postVerify() {
  return fromFetch(
    new Request(authwsEnvironment.verifyUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      credentials: 'include',
      body: JSON.stringify({
        product: environment.applicationName,
      }),
    })
  ).pipe(selectData(authUserSchema));
}
